import { render } from "./AppCheckoutShell.vue?vue&type=template&id=22f8fde8&ts=true"
import script from "./AppCheckoutShell.vue?vue&type=script&lang=ts"
export * from "./AppCheckoutShell.vue?vue&type=script&lang=ts"

import exportComponent from "/home/muhammadibrahim/Myserver/medix_envato_v4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__